"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CollectionItemVariable = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _VarsValueTypeHandler = require("../../type/VarsValueTypeHandler");
var _types = require("../../types");
class CollectionItemVariable {
  get enabled() {
    if (this.ref) {
      var _this$ref$value;
      return (_this$ref$value = this.ref.value()) === null || _this$ref$value === void 0 ? void 0 : _this$ref$value.value;
    }
    return true;
  }
  constructor() {
    (0, _defineProperty2.default)(this, "settings", CollectionItemVariable.settings);
    (0, _defineProperty2.default)(this, "type", "collection-item");
    (0, _defineProperty2.default)(this, "label", "Collection Item");
    (0, _defineProperty2.default)(this, "description", "Special variable that gets collected into collection variables.");
    (0, _defineProperty2.default)(this, "valueType", "value");
    (0, _defineProperty2.default)(this, "ref", void 0);
  }
  setReference(ref) {
    this.ref = ref;
  }
  dependencies(params, resolver) {
    let value;
    let forceBoolean = false;
    if (params.value) {
      value = _types.vals.value(resolver.resolve(params.value));
    } else {
      forceBoolean = true;
    }
    return {
      value,
      forceBoolean,
      collection: params.collection,
      checked: this.enabled
    };
  }
  getValue(ref, deps, batcher) {
    if (deps.forceBoolean) {
      ref.value = new _VarsValueTypeHandler.VarsMetaValue(deps.checked, "collection-item", {
        enabled: true
      });
    } else {
      ref.value = new _VarsValueTypeHandler.VarsMetaValue(deps.value, "collection-item", {
        enabled: deps.checked
      });
    }
    return null;
  }
}
exports.CollectionItemVariable = CollectionItemVariable;
(0, _defineProperty2.default)(CollectionItemVariable, "settings", {
  collection: {
    type: "collection",
    title: "Collection Name",
    description: "Name of the collection to add the value to."
  },
  value: {
    type: "var",
    title: "Value",
    description: "Value to add to the collection.",
    variableType: "value"
  }
});
//# sourceMappingURL=CollectionItemVariable.js.map